export const titles = {
    "home": "Pagos cooperativos de Bllink",
    "bllink": "Bllink",
    "page_description": "Pagos cooperativos de facturas en línea desde Bllink.co",
    "building_profile": "Página del edificio | Bllink",
    "tenant_details": "Detalles del inquilino | Bllink",
    "payment_details": "Detalles del pago | Bllink",
    "payment_checkout": "Pago de la compra | Bllink",
    "make_payment": "Página de pago | Bllink",
    "confirmation_page": "Confirmación de pago | Bllink",
    "bank_charge_guide": "Configurar instrucciones de cargos bancarios recurrentes | Bllink",
    "renewal_page": "Renovar pago | Bllink",
    "failed_payments_page": "Actualizar los datos de la tarjeta de crédito | Bllink",
    "terms_of_service": "Términos de uso | Bllink",
    "privacy": "Privacidad | Bllink",
    "all_buildings": "Mis edificios | Bllink",
    "dashboard": "Principal | Bllink",
    "yearly_report": "Informe anual | Bllink",
    "monthly_report": "Informe mensual | Bllink",
    "tenant_list": "Lista de inquilinos | Bllink",
    "apartment_report": "Informe de pagos de apartamentos | Bllink",
    "cash_flow_report": "Informe anual del flujo de efectivo | Bllink",
    "search_building": "Buscar por dirección | Bllink",
    "expenses_record": "Registro de gastos | Bllink",
    "monthly_expense_table": "Informe de gastos mensuales | Bllink",
    "loading": "Cargando",
    "forms": {
        "mandatory_field": "Este es un campo obligatorio",
        "mandatory_field_full_name": "Este es un campo obligatorio de 3 caracteres",
        "mandatory_above_zero": "El importe de los gastos debe ser superior a 0",
        "correct_email": "Introduce una dirección de correo electrónico correcta",
        "correct_account_bank_branch": "el banco, la sucursal y la cuenta deben completarse juntos",
        "correct_phone": "Introduce un número de teléfono móvil correcto",
        "subscribe_check": "Confirma los términos de uso",
        "going_to_credit_card": "Procesando...",
        "number_field": "Debe ser un número",
        "vendor_tax_id": "6 caracteres como mínimo",
        "min_string_size": "{{size}} caracteres como mínimo",
        "account_field": "Debe tener entre 6 y 9 caracteres",
        "correct_phone_for_vendor": "Verifica la longitud del número de teléfono entre 3 y 10 dígitos",
        "max_length_exceeded": "Max length for this field",
        "max_length": "Deben ser como máximo {{size}} caracteres",
        "min_length": "Debe tener al menos {{size}} caracteres",
        "invalid_card_number": "numero de tarjeta invalido",
        "invalid_cvv_code": "CVV no válido",
    },
    "bank_adjustments": "Ajustes bancarios | Bllink",
    "balance_report": "Informe de saldo | Bllink",
    "cheque_report": "Informe de depósito de cheques | Bllink",
    "expenses_edit": "Editar gastos | Bllink",
    "general_pop_up_title": "Notificación del sistema",
    "building_debt_list": "Lista de deudas del edificio | Bllink",
    "partner_debt_list": "Informe general de deudores | Bllink",
    "tenant_claims_paid": "Reclamaciones de inquilinos pagadas | Bllink",
    "coming_soon": "Muy pronto",
};
